import React from 'react';

export const RNYoutubePlayer = ({ videoId, ...props }: any) => {
  return <iframe src={`https://www.youtube.com/embed/${videoId}`} {...props} frameBorder={0} width={'100%'} />;
};
